import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { LastAttachmentsDocumentUploadReqest, LastAttachmentsDocumentUploadResponse, LastAttachmentsWidgetRequest } from '../models/last-attachments-widget';
import { FileResponse } from '../modules/tcm-core.module/models/files/file-response';

@Injectable({
  providedIn: 'root'
})
export class PatientDocumentDataService {

  constructor(private httpClient: ApiHttpClient) {
  }

  async downloadAndDisplayFileAsync(id: number | string): Promise<any> {
    try {
      const fileResponse = await this.downloadDocumentFileBlobAsync(id);
      await fileResponse.displayFileAsync();
    }
    catch (e) { }
  }

  public async downloadAndSaveDocumentFileAsync(id: number | string): Promise<any> {
    try {
      var fileResponse = await this.downloadDocumentFileBlobAsync(id);

      fileResponse.save();      
    }
    catch (e) {

    }
  }

  public uploadDocumentFileAsync(file: File, lastAttachmentsDocumentUploadReqest: LastAttachmentsDocumentUploadReqest): Promise<LastAttachmentsDocumentUploadResponse> {
    return this.httpClient.postFileAsync('lastAttachmentsWidget/uploadFile', file, lastAttachmentsDocumentUploadReqest);
  }

  public deleteDocumentAsync(id: number | string, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('patientdocuments/delete', id, timeout);
  }

  private downloadDocumentFileBlobAsync(id: number | string): Promise<FileResponse> {
    return this.httpClient.getFileAsync(`patientdocuments/download?id=${id.toString()}`);
  }

  public aggregatePatientDocumentsAsync(request: LastAttachmentsWidgetRequest, timeout: Promise<any>): Promise<FileResponse> {
    return this.httpClient.getFileAsync('lastAttachmentsWidget/AggregatePatientDocuments?request=' + JSON.stringify(request), {}, timeout);
  }
}
